








































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { StudentDifference, StudentDifferenceDataForDisplay } from '@/models/student/check-student-differences-result';

@Component({
  name: 'GStudentDifferencesTable',
  components: {},
  computed: {},
  methods: {},
})
export default class GStudentDifferencesTable extends Mixins(GPageBase) {
  currentPageNumber: number = 1;
  itemCountPerPage: number = 10;
  offset = 0;
  // 生徒差分結果のデータ（画面のpaging上に表示させる部分データ）
  displayData: StudentDifferenceDataForDisplay[] = [];
  // 生徒差分結果の全データ
  @Prop() data: StudentDifference[];
  // 姓名・メールアドレスとその他差分表示を分類のためのタイトル
  @Prop() title: string;

  get separatedData(): StudentDifferenceDataForDisplay[] {
    // 元々のデータを、現と新で2行に分割して表示するために変換を行う
    return this.data.map((studentDifference: StudentDifference) => new StudentDifference().deserialize(studentDifference).changeForDisplay).flat();
  }

  mounted() {
    this.setDisplayData();
  }

  handlePageChange(pageNumber: number) {
    // 差分確認のところは、現在と新で2行に増幅しているので、×2している
    this.offset = (pageNumber - 1) * this.itemCountPerPage * 2;
    this.currentPageNumber = pageNumber;
    this.setDisplayData();
  }

  setDisplayData() {
    const maxPageNumber = Math.floor(this.data.length / this.itemCountPerPage) + 1;
    if (this.currentPageNumber === maxPageNumber) {
      this.displayData = this.separatedData.slice(this.offset);
    } else {
      this.displayData = this.separatedData.slice(this.offset, this.offset + this.itemCountPerPage * 2);
    }
  }

  get tableColumns(): any {
    return [
      {
        title: this.$t('ROW_NO').toString(),
        slot: 'rowNum',
        width: 60,
        className: 'col-num-right',
      },
      {
        title: this.$t('SIGNIN_ID').toString(),
        slot: 'studentNumber',
        width: 100,
      },
      {
        title: this.$t('MANAGE_NUMBER').toString(),
        slot: 'manageNumber',
        width: 100,
        className: 'col-num-right',
      },
      {
        title: this.$t('GRADE').toString(),
        slot: 'grade',
        width: 100,
        className: 'col-num-right',
      },
      {
        title: this.$t('SCHOOL_CLASS').toString(),
        slot: 'schoolClassName',
        width: 100,
      },
      {
        title: this.$t('LAST_NAME').toString(),
        slot: 'lastName',
        width: 100,
      },
      {
        title: this.$t('FIRST_NAME').toString(),
        slot: 'firstName',
        width: 100,
      },
      {
        title: this.$t('FURIGANA_SEI').toString(),
        slot: 'lastNameKana',
        width: 100,
      },
      {
        title: this.$t('FURIGANA_MEI').toString(),
        slot: 'firstNameKana',
        width: 100,
      },
      {
        title: this.$t('TAG').toString(),
        slot: 'tag',
        width: 100,
      },
      {
        title: this.$t('MATCHING_EVALUATOR_GROUP').toString(),
        slot: 'priorityTagName',
        width: 100,
      },
      {
        title: this.$t('MAIL_ADDRESS').toString(),
        slot: 'contactEmail',
        width: 200,
      },
    ];
  }

  rowClassName(row: StudentDifferenceDataForDisplay, index: number): string {
    if (row.isNewData) {
      return '';
    } else {
      return 'student-difference-current-data-row';
    }
  }
}
